module.exports = __webpack_public_path__ + "img/arrow-right.84e0b1d2.svg";